import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface INewbuildingBrokerButtonProps {
  loading: boolean;
  onClick: () => void;
}

export const NewbuildingBrokerButton: React.VFC<INewbuildingBrokerButtonProps> = ({ loading, onClick }) => (
  <Button loading={loading} onClick={onClick} theme="fill_success_primary" fullWidth size="XS">
    Провести сделку
  </Button>
);
